import { tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import loaded from './loaded';
import loading from './loading';
import globalError from './globalError';
import { DESIGNS_SUMMARY_LOADED } from './actionTypes';

export default designIds => (dispatch) => {
  dispatch(loading());

  designBuilderApi
    .getDesignsSummary(designIds)
    .then(response => dispatch({
      type: DESIGNS_SUMMARY_LOADED,
      payload: response.data,
    }))
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
